var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shopimg)?_c('el-image',{staticClass:"img-box",attrs:{"src":_vm.shopimg,"fit":"cover"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }